import {
	ChangeDetectionStrategy,
	Component,
	input,
	OnChanges,
	output,
} from '@angular/core';
import { FormFieldLabelComponent } from '../../ui-components/form-field-label/form-field-label.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'entity-cost-form',
	imports: [
		FormFieldLabelComponent,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		NgxTolgeeModule,
	],
	templateUrl: './entity-cost-form.component.html',
	styleUrl: './entity-cost-form.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityCostFormComponent implements OnChanges {
	selectedCost = input<number>();
	maxNumOfDigits = input<number>(8);
	costChanged = output<number>();

	costForm = new FormControl(0, [
		Validators.pattern(`^\\d{1,${this.maxNumOfDigits()}}(\\.\\d{1,2})?$`),
	]);

	ngOnChanges(): void {
		this.costForm.setValue(this.selectedCost());
	}

	onBlur() {
		if (this.costForm.invalid || this.costForm.value === this.selectedCost()) {
			return;
		}
		this.costChanged.emit(this.costForm.value);
	}
}
